import { render, staticRenderFns } from "./ItemActions.vue?vue&type=template&id=deb32068&scoped=true&"
import script from "./ItemActions.vue?vue&type=script&lang=js&"
export * from "./ItemActions.vue?vue&type=script&lang=js&"
import style0 from "./ItemActions.vue?vue&type=style&index=0&id=deb32068&lang=scss&scoped=true&"
import style1 from "./ItemActions.vue?vue&type=style&index=1&id=deb32068&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb32068",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('deb32068')) {
      api.createRecord('deb32068', component.options)
    } else {
      api.reload('deb32068', component.options)
    }
    module.hot.accept("./ItemActions.vue?vue&type=template&id=deb32068&scoped=true&", function () {
      api.rerender('deb32068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/uniform-items/components/ItemActions.vue"
export default component.exports